import {
  Cog,
  Database,
  Globe,
  Images,
  LockKeyhole,
  PencilLine,
  Puzzle,
  Satellite,
  Shield,
  Users,
} from 'lucide-react'

import { ContractIcon } from '@/components/icons/contract'
import { EditNoteIcon } from '@/components/icons/edit-note'
import { HouseIcon } from '@/components/icons/house'
import { ManageAccountsIcon } from '@/components/icons/manage-accounts'
import { MonitoringIcon } from '@/components/icons/monitoring'
import { PatientListIcon } from '@/components/icons/patient-list'
import { PersonIcon } from '@/components/icons/person'
import { PersonEditIcon } from '@/components/icons/person-edit'
import { PersonWithSquare } from '@/components/icons/person-with-square'
import { PriceCheckIcon } from '@/components/icons/price-check'
import { RealEstateIcon } from '@/components/icons/real-estate'
import { ReviewsIcon } from '@/components/icons/reviews-icon'
import { ScoreIcon } from '@/components/icons/score'
import { SponsorshipsIcon } from '@/components/icons/sponsorships/sponsorships-icon'
import { SupervisorIcon } from '@/components/icons/supervisor'
import { TransferUserIcon } from '@/components/icons/transfer-user'

export const menuOptions: Array<{
  label: string
  path?: string
  icon: React.ReactNode
  type?: 'group'
  items?: {
    label: string
    path: string
    icon: React.ReactNode
    isDisabled?: boolean
  }[]
  isDisabled?: boolean
}> = [
  {
    label: 'Propriedades',
    path: '/backoffice/properties',
    icon: <HouseIcon className="shrink-0" />,
  },

  // TODO: Tirar comentário quando tiver a tela de Dashboard
  // {
  //   label: 'Dashboard',
  //   path: '/backoffice/dashboard',
  //   icon: <DashboardIcon className="shrink-0" />,
  // },

  {
    label: 'Conservadores',
    path: '/backoffice/preservers',
    icon: <PersonIcon className="shrink-0" />,
  },
  {
    label: 'Patrocinadores',
    path: '/backoffice/sponsors',
    icon: <RealEstateIcon className="shrink-0" />,
  },
  {
    label: 'Patrocínios',
    path: '/backoffice/sponsorships',
    icon: <SponsorshipsIcon className="size-6! shrink-0" />,
  },
  {
    label: 'Pagamentos',
    path: '/backoffice/payments',
    icon: <PriceCheckIcon className="shrink-0" />,
  },
  {
    label: 'Agentes',
    path: '/backoffice/agents',
    icon: <PersonWithSquare className="shrink-0" />,
  },
  {
    label: 'Supervisores',
    path: '/backoffice/supervisors',
    icon: <SupervisorIcon className="shrink-0" />,
  },
  {
    label: 'Signatários',
    type: 'group',
    icon: <PersonEditIcon className="shrink-0" />,
    items: [
      {
        label: 'Cadastrar',
        path: '/backoffice/signatories',
        icon: <ContractIcon className="shrink-0" />,
      },
      {
        label: 'Associar',
        path: '/backoffice/signatory/associations',
        icon: <PencilLine className="shrink-0" />,
      },
      {
        label: 'Função',
        path: '/backoffice/signatory-roles',
        icon: <Puzzle className="shrink-0" />,
      },
    ],
  },
  {
    label: 'Portal',
    type: 'group',
    icon: <Globe className="shrink-0" />,
    items: [
      {
        label: 'Publicações',
        path: '/backoffice/publications',
        icon: <EditNoteIcon className="shrink-0" />,
      },
      {
        label: 'Guardiões',
        path: '/backoffice/guardians',
        icon: <Shield className="shrink-0" />,
      },
      {
        label: 'Equipe',
        path: '/backoffice/team',
        icon: <Users className="shrink-0" />,
      },
      {
        label: 'Depoimentos',
        path: '/backoffice/testimonials',
        icon: <ReviewsIcon className="shrink-0" />,
      },
      {
        label: 'Banners',
        path: '/backoffice/banners',
        icon: <Images className="shrink-0" />,
      },
      {
        label: 'LGPD',
        path: '/backoffice/lgpd/users',
        icon: <LockKeyhole className="shrink-0" />,
      },
    ],
  },
  {
    label: 'Acessos',
    type: 'group',
    icon: <PersonEditIcon className="shrink-0" />,
    items: [
      {
        label: 'Administradores',
        path: '/backoffice/users',
        icon: <ManageAccountsIcon className="shrink-0" />,
      },
      {
        label: 'Perfis',
        path: '/backoffice/profile/association',
        icon: <TransferUserIcon className="shrink-0" />,
      },
    ],
  },
  {
    label: 'Integração',
    type: 'group',
    icon: <Database className="shrink-0" />,
    items: [
      {
        label: 'Configurações',
        path: '/backoffice/config',
        icon: <Cog className="shrink-0" />,
      },
      {
        label: 'Satélites',
        path: '/backoffice/integration/worker/blockchain',
        icon: <Satellite className="shrink-0" />,
      },
      {
        label: 'Score',
        path: '/backoffice/scores',
        icon: <ScoreIcon className="shrink-0" />,
      },
      {
        label: 'Histórico',
        path: '/backoffice/log',
        icon: <PatientListIcon className="shrink-0" />,
      },
    ],
  },
  {
    label: 'Simulação',
    path: '/backoffice/process/simulation',
    icon: <MonitoringIcon className="shrink-0" />,
  },
]
